export type AccuracyViewMode = 'revenue' | 'units';

export interface ForecastAccuracyPeriodValues {
    forecast: number | null;
    actual: number | null;
    variance: number | null;
    absoluteVariance: number | null;
    forecastUnits?: number | null;
    actualUnits?: number | null;
    forecastRevenue?: number | null;
    actualRevenue?: number | null;
}

export const hasDualAccuracyMetrics = (
    period: ForecastAccuracyPeriodValues | null | undefined
): boolean => {
    if (!period) {
        return false;
    }
    return period.forecastUnits !== undefined || period.forecastRevenue !== undefined;
};

export const calculateAccuracyVariance = (
    forecast: number | null,
    actual: number | null
): { variance: number | null; absoluteVariance: number | null } => {
    if (actual === null || actual === undefined) {
        return { variance: null, absoluteVariance: null };
    }

    const forecastValue = forecast ?? 0;
    const absoluteVariance = actual - forecastValue;
    const variance = forecastValue === 0
        ? (actual !== 0 ? 100 : 0)
        : ((actual - forecastValue) / forecastValue) * 100;

    return { variance, absoluteVariance };
};

export const resolveAccuracyPeriod = (
    period: ForecastAccuracyPeriodValues,
    viewMode: AccuracyViewMode
): ForecastAccuracyPeriodValues => {
    if (!hasDualAccuracyMetrics(period)) {
        return period;
    }

    const forecast = viewMode === 'revenue'
        ? period.forecastRevenue ?? null
        : period.forecastUnits ?? null;
    const actual = viewMode === 'revenue'
        ? (period.actualRevenue ?? null)
        : (period.actualUnits ?? null);
    const { variance, absoluteVariance } = calculateAccuracyVariance(forecast, actual);

    return {
        ...period,
        forecast,
        actual,
        variance,
        absoluteVariance
    };
};
